import { userInfoSync } from 'hub-http/userInfo';
const applyScopeModifications = scopes => {
  let rawScopesToAdd = '';
  let rawScopesToRemove = '';
  try {
    rawScopesToAdd = window.localStorage.getItem('SELENIUM_SCOPES_TO_ADD') || '';
    rawScopesToRemove = window.localStorage.getItem('SELENIUM_SCOPES_TO_REMOVE') || '';
  } catch (e) {
    console.warn('Couldnt load up scope modifications');
  }
  rawScopesToAdd.split(',').forEach(scopeToAdd => {
    if (scopeToAdd && !scopes.includes(scopeToAdd)) {
      scopes.push(scopeToAdd);
    }
  });
  rawScopesToRemove.split(',').forEach(scopeToRemove => {
    const scopeIndex = scopes.findIndex(scope => scope === scopeToRemove);
    if (scopeIndex > -1) {
      scopes.splice(scopeIndex, 1);
    }
  });
  return scopes;
};
// TODO: remove with resolution of Monarch hs-pages-fe/2026-Q3/176030:
// PageDowngradedMofoFields depend on scope add/remove being consistent in Redux store <> userInfoSync cache...
// The following utils allow AT runs to log snapshots of the scope "state" across the two at secific timestamps to help debugging.
const WATCHED_SCOPES = ['cta-access', 'calls-to-action-read', 'marketing-video', 'meetings-personal-link-create', 'meetings-team-link-create'];
export const recordScopeDebug = (label, scopes) => {
  try {
    if (!window.SELENIUM_IS_RUNNING) {
      return;
    }
    const entry = {
      label,
      ts: Date.now()
    };
    if (scopes) {
      entry.reduxScopes = scopes.filter(scope => WATCHED_SCOPES.includes(scope));
    }
    try {
      const cached = userInfoSync();
      if (cached && cached.user) {
        entry.userInfoSyncScopes = [...(cached.user.scopes || [])].filter(scope => WATCHED_SCOPES.includes(scope));
      } else {
        entry.userInfoSyncError = 'not populated';
      }
    } catch (e) {
      entry.userInfoSyncError = 'not populated';
    }
    const seleniumAppState = window.SELENIUM_APP_STATE = window.SELENIUM_APP_STATE || {};
    if (!Array.isArray(seleniumAppState.scopeDebug)) {
      seleniumAppState.scopeDebug = [];
    }
    seleniumAppState.scopeDebug.push(entry);
  } catch (e) {
    // Debug logging should never throw
  }
};

// Lets the acceptance test snapshot the scope state at assertion time
export const logCurrentScopeState = (label = 'on-demand-log') => {
  recordScopeDebug(label);
};

// hub-http's userInfo() repeatedly overwrites its memoized cache with the original, unmodified scopes at resolution time
// Re-apply the scope mods on `hubspot:userinfochange` event so the cache does not diverge from Redux
export const reapplyScopeModificationsToUserInfoCache = () => {
  if (!window.SELENIUM_IS_RUNNING) {
    return;
  }
  let cached;
  try {
    cached = userInfoSync();
  } catch (e) {
    // hub-http cache not yet populated; nothing to re-apply to
    return;
  }
  if (!cached || !cached.user) {
    return;
  }
  recordScopeDebug('userinfochange-reapply-before');
  cached.user.scopes = applyScopeModifications([...(cached.user.scopes || [])]);
  recordScopeDebug('userinfochange-reapply-after');
};
let listenerIsRegistered = false;

// Opt in from the same call sites that ask modifyScopesForSelenium to sync hub-http's cache.
// Callers that only want the Redux store scopes modified keep hub-http's cache untouched.
export const keepUserInfoCacheScopesInSync = () => {
  if (listenerIsRegistered || !window.SELENIUM_IS_RUNNING) {
    return;
  }
  listenerIsRegistered = true;
  window.addEventListener('hubspot:userinfochange', reapplyScopeModificationsToUserInfoCache);
};
export const modifyScopesForSelenium = (scopes, userInfoCache) => {
  const modifiedScopes = applyScopeModifications(scopes);

  // Also override hub-http's userInfoSync cache so shared libraries (ContentUILib, etc.) that read scopes via userInfoSync() see the same modified scopes as the Redux store.
  // This is only needed because SELENIUM_SCOPES_TO_REMOVE is a test-only mechanism that modifies Redux store scopes but not hub-http's cache.
  if (userInfoCache !== null && userInfoCache !== void 0 && userInfoCache.user) {
    userInfoCache.user.scopes = modifiedScopes;
  }
  return modifiedScopes;
};